import { t } from 'i18next';
import template from './template';
import img from './images/yola-black-ua-e089285c.png';
import prepareFadeIn from '../../utils/fade-in';
import parseElementFromString from '../../utils/parse-element-from-string';
import Configuration from '../../modules/configuration';

function initialize() {
  const config = Configuration.get();
  
  const data = {
    url: config.getSignupUrl(),
    buttonText: t('Built with'),
    img,
  };
  
  const madeWithComponent = parseElementFromString(template(data));
  const animation = prepareFadeIn(madeWithComponent);

  document.body.appendChild(madeWithComponent);
  
  animation.run();
}

export default initialize;
